import { useMemo } from 'react';
import type { FC } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Container } from '..';
import * as Styled from './styled';
import type { RelatedLinksProps } from './types';

export * from './types';

export const RelatedLinks: FC<RelatedLinksProps> = (props) => {
  const { categories } = props;

  const relatedLinks = useMemo(() => {
    return categories
      .filter((category) => category.items.length > 0)
      .map((category, index) => (
        <Styled.Section key={index}>
          <Styled.Title>{category.label}</Styled.Title>
          <Styled.LinksContainer>
            {category.items.map((item, itemIndex) => (
              <Styled.Link key={itemIndex}>
                <Link to={item.link}>
                  <span>{item.label}</span>
                  <FaChevronRight />
                </Link>
              </Styled.Link>
            ))}
          </Styled.LinksContainer>
        </Styled.Section>
      ));
  }, [categories]);

  return (
    <Styled.Banner>
      <Container>
        <Styled.Wrapper>{relatedLinks}</Styled.Wrapper>
      </Container>
    </Styled.Banner>
  );
};
